import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const InputMeals = ({ number, selectedMeals, setSelectedMeals }) => {
    const { t } = useTranslation();
    const options = [
        { value: 1, label: t('without meals') },
        { value: 2, label: t('1 meal') },
        { value: 3, label: t('2 meals') },
        { value: 4, label: t('3 meals') }
    ];

    const _setSelectedMeals = setSelectedMeals||(() => {});

    //console.log(`InputMeals(): key:`, number);

    const handleChange = (selectedOption) => {
        _setSelectedMeals(selectedOption);
    };

    return (
        <div className='input-meal'>
            <label>{number}.</label>
            <Select
                className='meal-select'
                value={selectedMeals}
                onChange={handleChange}
                options={options}
                defaultValue={options[0]}
                isMulti={false}
                placeholder={t('Dietary options...')}
            />
        </div>
    );
};

export default InputMeals;
